<aionz-header-bottom-sheet
  aionz-dialog-title
  (onClose)="close()">
  Pedidos integrados ao ERP
  <p class="order-text">#{{ data.id }}</p>
</aionz-header-bottom-sheet>

<aionz-dialog-content class="product-list">
  @if (displayItems.length === 0) {
    <aionz-empty-content
      title="Nenhum pedido encontrado"
      description="Não há pedidos integrados ao ERP para este item."
      icon="receipt_long">
    </aionz-empty-content>
  } @else {
    @for (item of displayItems; track item.orderCode) {
      <aionz-order-history-accordion [item]="item" />
    }
  }
</aionz-dialog-content>
